import React from "react";
import { Route, Switch } from "react-router-dom";
import ServicesTable from "./ServicesTable";
import ServicesTasksTable from "./ServicesTasksTable";
import ServicesForm from "./ServicesFormNew";
import ServiceTasksForm from "./ServiceTasksForm";
import WriteRoute from "../../shared/components/WriteRoute";

export default () => (
  <Switch>
    <Route exact path="/services/services" component={ServicesTable} />
    <Route exact path="/services/servicetasks" component={ServicesTasksTable} />
    <WriteRoute
      exact
      path="/services/services/addnew"
      component={ServicesForm}
      redirectTo="/services/services"
    />
    <WriteRoute
      exact
      path="/services/servicetasks/addnew"
      component={ServiceTasksForm}
      redirectTo="/services/servicetasks"
    />
  </Switch>
);
